export const USER_SETTINGS_DAM = 'user_settings_dam';

export const Settings = {
  GALLERY_MODE: 'gallery_mode',
};
